(function()
{
	var Application = include("springroll.Application");
	var Debug = include("springroll.Debug", false);
	var Ease = include("createjs.Ease");
	var Tween = include("createjs.Tween");
	var UnitContainer = include("nature.UnitContainer");

	/**
	 * Seed actions is a mixin created to add functionality to both a new Seed() and to a floater life powerup that needs to become a seed.
	 * @mixin SeedActions
	 */
	var SeedActions = function()
	{
		this.shield = false;
		// Initial the rotation to 1 spin so the first tween doesn't go wonky deciding how far the spin is from null/0
		this.spinCount = 1;
		this.art.item.rotation = this.origRotation = 0;

		Object.defineProperty(this, 'floating',
		{
			get: function()
			{
				return this._floating;
			},
			set: function(bool)
			{
				this._floating = bool;
				if (bool && !this.tween)
				{
					this.start();
				}
				if (this.tween)
				{
					this.tween.setPaused(!bool);
				}
			}
		});
	};

	var s = UnitContainer.prototype;
	var p = extend(SeedActions, UnitContainer);

	/**
	 * Add and start the floating tween on this container 
	 */
	p.start = function()
	{
		var configSeeds = this.app.config.seeds;
		var ease = Ease[configSeeds.idle.ease];
		var time = configSeeds.idle.time;

		this.tween = Tween.get(this,
		{
			loop: true
		}).to(
		{
			y: this.y + configSeeds.idle.y
		}, time, ease).to(
		{
			y: this.y
		}, time, ease);

		this.tween.setPaused(true);
	};

	p.stop = function()
	{
		if (this.art)
		{
			Tween.removeTweens(this.art);
		}
		this.floating = false;
		this.tween = null;
	};

	p.spin = function(wait, time)
	{
		var finalRotation = this.origRotation - (360 * ++this.spinCount);
		Tween.get(this.art.item).wait(wait).to(
			{
				rotation: finalRotation
			},
			time, //¶
			[
				Ease.cubicOut,
				Ease.quartOut,
			].random()
		);
	};

	p.destroy = function()
	{
		this.stop();
		this.art = null;
		if (this.shieldBubble)
		{
			this.removeChild(this.shieldBubble);
			this.shieldBubble = null;
		}
		s.destroy.call(this);
	};

	namespace("nature").SeedActions = SeedActions;
}());
